'use strict';

var _require = require('lodash'),
    getIn = _require.get;

var transferEvents = require('../constants/transferEvents');
var _transferEvents$Event = transferEvents.EventType,
    ObjectFullMove = _transferEvents$Event.ObjectFullMove,
    ObjectFullSkip = _transferEvents$Event.ObjectFullSkip,
    ObjectPartSkip = _transferEvents$Event.ObjectPartSkip;
var Failure = transferEvents.StatusCode.Failure;


var getStatus = function getStatus(transferEvent) {
    var type = transferEvent.type;

    // ObjectPartSkips currently do not have a status as they could never fail
    if (type === ObjectPartSkip) {
        return null;
    }

    // First check the transferEvent.status. Newer jet servers will be sending a status at the top level of the event
    var status = transferEvent.status;

    if (!status) {
        status = type === ObjectFullSkip ? transferEvent.statusInfo : getWriteStageInfo(transferEvent).statusInfo;
    }

    return status;
};

var getWriteStageInfo = function getWriteStageInfo(transferEvent) {
    var writeStageItems = getIn(transferEvent, 'transferInfo.stage.write');
    return writeStageItems[writeStageItems.length - 1];
};

var getFileType = function getFileType(transferEvent) {
    return getIn(transferEvent, 'objectInfo.type');
};

var getSourceUrl = function getSourceUrl(transferEvent) {
    return getIn(transferEvent, 'objectInfo.urls.source');
};

var getObjectSize = function getObjectSize(transferEvent) {
    return getIn(transferEvent, 'objectInfo.size.bytes', 0);
};

var getObjectModTime = function getObjectModTime(transferEvent) {
    var objectModTime = getIn(transferEvent, 'objectInfo.modTime');
    return objectModTime !== null ? objectModTime : void 0;
};

var getPartSize = function getPartSize(transferEvent) {
    return getIn(transferEvent, 'partInfo.sizeInBytes', 0);
};

var isSinglePartObjectFullMoveEvent = function isSinglePartObjectFullMoveEvent(transferEvent) {
    return transferEvent.type === ObjectFullMove && getIn(transferEvent, 'objectInfo.size.parts') === 1;
};

var isFailureEvent = function isFailureEvent(transferEvent) {
    // ObjectPartSkips are never failures
    if (transferEvent.type === ObjectPartSkip) {
        return false;
    }

    var statusInfo = getStatus(transferEvent);

    return statusInfo.statusCode === Failure;
};

var getFileCounts = function getFileCounts(postTransferEvent) {
    var getFileCount = function getFileCount(category) {
        return getIn(postTransferEvent, 'transferInfo.write.objects.' + category + '.count', 0);
    };
    return {
        pass: getFileCount('pass'),
        skip: getFileCount('skip'),
        fail: getFileCount('fail')
    };
};

var getFileBytes = function getFileBytes(postTransferEvent) {
    var getBytes = function getBytes(category) {
        return getIn(postTransferEvent, 'transferInfo.write.objects.' + category + '.bytes', 0);
    };
    var pass = getBytes('pass');
    var skip = getBytes('skip');
    var fail = getBytes('fail');
    return { pass: pass, skip: skip, fail: fail, total: pass + skip + fail };
};

var getMovingAvgTransferRate = function getMovingAvgTransferRate(transferEvent) {
    return getIn(transferEvent, 'objectInfo.transferRate.movingAvgInBitsPerSecond');
};

var getRunningAvgTransferRate = function getRunningAvgTransferRate(transferEvent) {
    return getIn(transferEvent, 'objectInfo.transferRate.runningAvgInBitsPerSecond');
};

module.exports = {
    getObjectSize: getObjectSize,
    getObjectModTime: getObjectModTime,
    getPartSize: getPartSize,
    getSourceUrl: getSourceUrl,
    isSinglePartObjectFullMoveEvent: isSinglePartObjectFullMoveEvent,
    isFailureEvent: isFailureEvent,
    getStatus: getStatus,
    getFileType: getFileType,
    getFileCounts: getFileCounts,
    getFileBytes: getFileBytes,
    getMovingAvgTransferRate: getMovingAvgTransferRate,
    getRunningAvgTransferRate: getRunningAvgTransferRate
};